/* Read-only presentation of the selected bundle's existing displayed prices. */
(() => {
  const marker = document.getElementById('rce-header');
  const root = marker && marker.closest('section');
  if (!root || root.dataset.roloofPriceDisplay) return;
  root.dataset.roloofPriceDisplay = 'true';
  let frame;
  const moneyValue = (text) => {
    let value = text.replace(/[^\d.,]/g, '');
    const decimal = value.match(/[.,](\d{2})$/);
    return decimal
      ? Number(value.slice(0, -3).replace(/[.,]/g, '') + '.' + decimal[1])
      : Number(value.replace(/[.,]/g, ''));
  };
  const setText = (node, value) => {
    if (node.textContent !== value) node.textContent = value;
  };
  function render() {
    frame = null;
    const host = root.querySelector('.product-page-price');
    if (!host) return;
    const selected = root.querySelector('kaching-bundles-block .kaching-bundles__bar--selected');
    const priceText = selected?.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
    const compareText = selected?.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim() || '';
    if (!priceText) {
      host.classList.remove('roloof-bundle-price-active');
      host.querySelector('.roloof-bundle-price-display')?.remove();
      return;
    }
    let display = host.querySelector('.roloof-bundle-price-display');
    if (!display) {
      display = document.createElement('div');
      display.className = 'roloof-bundle-price-display';
      display.innerHTML = '<span class="roloof-bundle-total"></span><s class="roloof-bundle-compare"></s><span class="roloof-bundle-saving"><span></span></span>';
      const icon = host.querySelector('.price__badge-sale svg');
      if (icon) display.querySelector('.roloof-bundle-saving').prepend(icon.cloneNode(true));
      host.append(display);
    }
    const nativePrice = host.querySelector('.price--on-sale .price__sale .main-price') || host.querySelector('.price__regular .main-price');
    if (nativePrice) {
      const style = getComputedStyle(nativePrice);
      display.style.setProperty('--roloof-price-color', style.color);
      display.style.setProperty('--roloof-price-size', style.fontSize);
      display.style.setProperty('--roloof-price-weight', style.fontWeight);
    }
    setText(display.querySelector('.roloof-bundle-total'), priceText);
    const current = moneyValue(priceText);
    const compare = moneyValue(compareText);
    const hasSaving = Number.isFinite(current) && Number.isFinite(compare) && compare > current;
    const compareNode = display.querySelector('.roloof-bundle-compare');
    setText(compareNode, hasSaving ? compareText : '');
    compareNode.hidden = !hasSaving;
    const saving = display.querySelector('.roloof-bundle-saving');
    saving.hidden = !hasSaving;
    if (hasSaving) setText(saving.querySelector('span'), 'SAVE ' + Math.round((compare - current) / compare * 100) + '%');
    host.classList.add('roloof-bundle-price-active');
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(render);
  }
  const observer = new MutationObserver((records) => {
    if (records.some(({ target }) => {
      const element = target.nodeType === 1 ? target : target.parentElement;
      return element && !element.closest('.roloof-bundle-price-display, .product-page-price');
    })) schedule();
  });
  observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  root.addEventListener('change', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', schedule);
  render();
})();
